import Legend from 'components/molecules/Legend';
import { colorConstants } from 'config/colorConstants';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import React, { useContext, useEffect, useMemo } from 'react';
import { CustomTable, tableHeight } from './SummarySection';
import { getPlaybookColumns } from 'utils/getRecommendationTableColumns';
import { useFetchPlaybookData } from 'hooks/promoRecommendation/useFetchPlaybook';
import { getConfig } from 'utils/helperMethods';
import { UserContext } from 'contexts/ConfigContext';
import { newPlanValue } from 'hooks/promoRecommendation/useFetchGetPlans';

const legendItems = [
    {
        label: 'Compliant',
        color: colorConstants.limeGreen,
        style: { borderRadius: 2 },
    },
    {
        label: 'Non-Compliant',
        color: colorConstants.red,
        style: { borderRadius: 2 },
    },
];

const emptyText = 'Please select a Scenario from the recommendations page in order to view the Playbook';

const PlaybookSection = () => {
    const { appConfig } = useContext(UserContext);
    const { selectedPlan } = useContext(promoRecommendation);
    const promoRecommendationConfig = getConfig('promoRecommendation', appConfig);

    const {
        data: playbookData,
        loading: playbookLoading,
        error: playbookError,
        fetchPlaybookData,
    } = useFetchPlaybookData();

    useEffect(() => {
        if (selectedPlan?.value !== newPlanValue)
            fetchPlaybookData({
                variables: {
                    planId: selectedPlan?.planId,
                    limit: promoRecommendationConfig?.playbookLimit,
                    offset: 0,
                },
            });
    }, [selectedPlan]);

    const tableColumns = useMemo(() => {
        if (playbookData) return getPlaybookColumns(playbookData);
    }, [playbookData]);
    return (
        <div>
            {selectedPlan?.value !== newPlanValue ? (
                <>
                    <div className="flex justify-between">
                        <p className="font-sm text-promoColour">SRM Guidelines vs {selectedPlan?.label || ''}</p>
                        <Legend className="legend-size-square" data={legendItems} />
                    </div>
                    <div className="mt-4">
                        <CustomTable
                            loading={playbookLoading}
                            //bordered
                            pagination={false}
                            scroll={{ x: '100%', y: tableHeight }}
                            sticky
                            columns={tableColumns}
                            dataSource={playbookData}
                        />
                    </div>
                </>
            ) : (
                <div
                    className="flex font-md justify-center items-center text-borderGrey"
                    style={{ height: tableHeight }}
                >
                    {emptyText}
                </div>
            )}
        </div>
    );
};

export default PlaybookSection;
